export const homeStructuredData = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  name: "H&W Concrete - Brevard County's Leading Concrete Contractor",
  description:
    "H&W Concrete specializes in residential and commercial concrete projects in Brevard County, Florida. Expert concrete driveways, patios, sidewalks, and custom work.",
  url: "https://hwconcrete.com",
  mainEntity: {
    "@type": "LocalBusiness",
    name: "H&W Concrete",
    description:
      "Professional concrete contractor serving Brevard County, Florida",
    telephone: "+1-321-208-0016",
    email: "patrick@hwconcrete.com",
    address: {
      "@type": "PostalAddress",
      addressRegion: "FL",
      addressCountry: "US",
      addressLocality: "Brevard County",
    },
    areaServed: "Brevard County, Florida",
    serviceType: [
      "Concrete Driveways",
      "Concrete Patios",
      "Concrete Sidewalks",
      "Garage Slabs",
      "Custom Concrete Work",
    ],
  },
};
